import { useMemo } from "react";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { getVesselCallById } from "@services/vesselCallApi";
import { useQuery } from "@tanstack/react-query";

const SERVICE = "bff-vessel-call";

export const useCheckOwnersMatter = (vesselCallId: string) => {
  const { user } = useAuthStore();

  const { data: vesselCallDetails } = useQuery({
    queryKey: ["vesselCallDetails", vesselCallId],
    queryFn: () => getVesselCallById(SERVICE, vesselCallId),
  });

  const isOwnersMatter = useMemo(() => {
    return user?.companyId === vesselCallDetails?.ownersMattersAgent;
  }, [vesselCallDetails, user]);

  return isOwnersMatter;
};
